'use client';

import dynamic from 'next/dynamic';
import { Suspense } from 'react';

const AnalyticsTracker = dynamic(
  () => import('@/app/components/analytics/analytics-tracker'),
  { ssr: false }
);

const BackToTop = dynamic(() => import('@/app/components/ui/back-to-top'), {
  ssr: false,
});


export default function ClientOnlyComponents() {
  return (
    <>
      <Suspense fallback={null}>
        <AnalyticsTracker />
      </Suspense>
      <BackToTop />
    </>
  );
}